export default {
    'updated': 'Notificarea a fost actualizata',
    'deleted': 'Notificarea a fost stearsa',
    'restored': 'Notificarea a fost restaurata'
}
